import { IAIAgentMessage } from '@/pages/AIAgent/ai-agent.types.ts'
import css from './message-item.module.css'
import timeUtils from '@/utils/time.utils.ts'
import cn from '@/utils/cn.ts'
import AssistantIcon from '@/assets/icons/ai-icon.svg?react'
import ReactMarkdown from 'react-markdown'

interface IProps {
  message: IAIAgentMessage
}

const MessageItem = ({ message }: IProps) => {
  const renderName = () => {
    if (message.role === 'user') {
      return <span className={cn('text-sm', css.roleText)}>Вы</span>
    }

    return (
      <div className="inline-flex-gap gap8 center">
        <AssistantIcon style={{ width: '16px', height: '16px' }} />
        <span className="text-sm text-primary">Ассистент</span>
      </div>
    )
  }

  return (
    <div className={css.message} data-from={message.role}>
      <div className={css.messageMeta}>
        {renderName()}
        {message.role === 'user' && (
          <div className="inline-flex-gap gap8 center">
            <span className={cn('text-sm', css.timeText)}>
              {timeUtils.formatDate(message.createdAt, 'dd MMM yyyy, HH:mm') || ''}
            </span>
          </div>
        )}
      </div>
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p className={cn(css.messageText, 'text-lg')} {...props} />,
          li: ({ node, ...props }) => (
            <li style={{ whiteSpace: 'unset' }} className={cn(css.messageText, 'text-lg')} {...props} />
          ),
          ol: ({ node, ...props }) => <ol style={{ marginLeft: '32px' }} {...props} />,
          ul: ({ node, ...props }) => <ul style={{ marginLeft: '32px' }} {...props} />,
        }}
      >
        {message.markdownText}
      </ReactMarkdown>
    </div>
  )

  //  <p className={cn(css.messageText, 'text-lg')}>
}

export default MessageItem
